var cssInstalledChunks = {};
var cssLoadingUniqueName = "@github-ui/github-ui";
var loadingAttribute = "data-rspack-loading";
var cssLoadStylesheet = (chunkId, url, done, hmr, fetchPriority) => {
	var link,
		needAttach,
		key = "chunk-" + chunkId;
	if (!hmr) {
		var links = document.getElementsByTagName("link");
		for (var i = 0; i < links.length; i++) {
			var l = links[i];
			var href = l.getAttribute("href") || l.href;
			if (href && !href.startsWith(__webpack_require__.p)) {
				href =
					__webpack_require__.p + (href.startsWith("/") ? href.slice(1) : href);
			}
			if (
				l.rel == "stylesheet" &&
				((href && href.startsWith(url)) ||
					l.getAttribute("data-rspack") == cssLoadingUniqueName + ":" + key)
			) {
				link = l;
				break;
			}
		}
		if (!done) return link;
	}
	if (!link) {
		needAttach = true;
		link = document.createElement("link");

if (__webpack_require__.nc) {
  link.setAttribute("nonce", __webpack_require__.nc);
}


link.setAttribute("data-rspack", cssLoadingUniqueName + ":" + key);


link.setAttribute(loadingAttribute, 1);
link.rel = "stylesheet";
link.href = url;

if (link.href.indexOf(window.location.origin + '/') !== 0) {
  link.crossOrigin = 'anonymous';
}



	}
	var onLinkComplete = (prev, event) => {
		link.onerror = link.onload = null;
		link.removeAttribute(loadingAttribute);
		clearTimeout(timeout);
		if (event && event.type != "load" && link.parentNode) link.parentNode.removeChild(link);
		done(event);
		if (prev) return prev(event);
	};
	if (link.getAttribute(loadingAttribute)) {
		var timeout = setTimeout(
			onLinkComplete.bind(null, undefined, { type: "timeout", target: link }),
			120000 
		);
		link.onerror = onLinkComplete.bind(null, link.onerror);
		link.onload = onLinkComplete.bind(null, link.onload);
	} else onLinkComplete(undefined, { type: "load", target: link });
	hmr ? document.head.insertBefore(link, hmr) : needAttach && document.head.appendChild(link);
	return link;
};
__webpack_require__.f.css = (chunkId, promises, fetchPriority) => {
	// css chunk loading
	var installedChunkData = __webpack_require__.o(cssInstalledChunks, chunkId)
		? cssInstalledChunks[chunkId]
		: undefined;
	if (installedChunkData !== 0) {
		// 0 means "already installed".

		// a Promise means "currently loading".
		if (installedChunkData) {
			promises.push(installedChunkData[2]);
		} else {
			if (/^(m([1bop]|1s|4p|a2|bv|ef|ft|hm|j3|lc|ot|pe|qe|qi|zk)|n([07bdioqr]|2[3mu]|[9cw]5|57|bx|jx|ky|pb|ya|ze)|2(57|7y|86|c|ci|d6|g3|hd|jg|k4|s)|f([lmpw]|2j|4t|bm|d3|f9|n7|ob|rd|sl|to|vi|wi|wn|x5)|q(15|4|4j|j7|k4|mc|v0|wy|x|yb)|w([27ehjlvw]|0q|1v|57|a6|cf|gz|ry)|z([0bcgm]|51|81|a9|dw|f4|fs|we)|o([lux]|15|4n|8t|dj|f6|fo|hu|wz|zc)|k([3fmwz]|1f|1z|4h|89|f4|lb|q9|r2|ya|zb)|d([25cefikz]|30|4j|gb|o4|pi|s5|v7)|l([cdkqu]|7d|b0|h5|h8|iy|sj|ym)|7([38aijw]|2[adg]|5z|a2|gn)|b([nvz]||3t|bh|kn|oc|sc|xt)|9([0dehklq]|87|9u|am|be|gn|j2|mq|p9|sw|sx)|r([1569cjmt]|02|7a|gw|hk|n6|oo|q7|xd|zx)|0([9dgjkp]|1k|1q|ag|aj|bc|igq|jt|q9d|vb|xz)|t([cdin]|09|3w|51|a6|ah|gm|l3|llv|n9|qd|qs|ue|xs)|i([15chkou]|r[4iz]|4o|99|a2|ap|b6|ix|kr|lw|m3|nj|ns|ot|wl)|x([jlz]|2y|4x|9l|bv|gd|hy|jm|mx5|rh|y4|yc|zc|zt)|h([128]|a[58o]|[4wy]z|4b|cx|g2|gj|j6|t8|up)|j([59dipv]|29|4f|7g|a4|dp|wb|wf)|3(71|92|d|e|fl|h7|r4|wj|zr)|s([3bly]|[6cj]1|0a|d9|he|hs|kd|kj|me|r3|tz|vp)|v(k[dhn]|11|7|8p|9l|b3|ct|n4|og|pr|ws)|1([17fimosw]|00|8m|f1|jf|lg|mu|qo|rv|u9|x7)|8([8cehkrstwx]|[1ew]s|2x|e8|gu|hi|nm|ov|qc|w4)|g([19e]|xu|yb|yf|zt)|p([2ds]|3x|6o|ds|n8|yv)|4([17ahv]|17|2w|76|7e|ea|eg|ft|uu|v5)|a([2jnw]|3u|7h|7y|9o|ck|cv|do|fc|ik|k3|rf)|5([4567]|00|0s|1p|6n|mz|rd|s9)|c([48k]|23|4t|mi|n9|x4)|6([13cgv]|3t|6x|8y|9a|cd|fq|fu|jg|ns|vyp|xm|yb)|u([48vx]|2l|3s|cj|dt|gm|hn|u8|w8|wq)|e([2459ahr]|2b|85|ah|av|ez|ft|lr|mz|qh|qv|tk3|vi|vw|wc|wo)|y([krxy]|2q|7n|ek|g7|ji|l8|lv|tp))$/.test(chunkId)) {
				// setup Promise in chunk cache
				var promise = new Promise(function (resolve, reject) {
					installedChunkData = cssInstalledChunks[chunkId] = [resolve, reject];
				});
				promises.push((installedChunkData[2] = promise));

				// start chunk loading
				var url = __webpack_require__.p + __webpack_require__.k(chunkId);
				// create error before stack unwound to get useful stacktrace later
				var error = new Error();
				var loadingEnded = function (event) {
					if (__webpack_require__.o(cssInstalledChunks, chunkId)) {
						installedChunkData = cssInstalledChunks[chunkId];
						if (installedChunkData !== 0) cssInstalledChunks[chunkId] = undefined;
						if (installedChunkData) {
							if (event.type !== "load") {
								var errorType = event && event.type;
								var realSrc = event && event.target && event.target.src;
								error.message =
									"Loading css chunk " +
									chunkId +
									" failed.\n(" +
									errorType +
									": " +
									realSrc +
									")";
								error.name = "ChunkLoadError";
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							} else {
								cssInstalledChunks[chunkId] = 0;
								installedChunkData[0]();
							}
						}
					}
				};
				if (typeof document !== 'undefined') {
					cssLoadStylesheet(chunkId, url, loadingEnded, undefined, fetchPriority);
				} else { loadingEnded({ type: 'load' }); }
			} else cssInstalledChunks[chunkId] = 0;
		}
	}
};
